import { API_URL } from "consts";
import { getResultFormData } from "utils/helpers";
import { getTypedVal, setURL, getURL } from "utils/urls";

export function createPDFLink(pdfLink: string, language: string): string {
  const hostName = API_URL;
  const { reportComment, reportId, reportLocation, reportName, reportRoadName } = getResultFormData();

  if (getTypedVal("htr_url_statefulurl")) {
    const tmp_pdf_lnk = pdfLink.replace("lang_code", "doof");
    const new_url = hostName + tmp_pdf_lnk.replace(location.host, "").replace("http://", "").replace("https://", "");
    setURL("pdf_header_margin_top", getTypedVal("pdf_header_margin_top", "3cm"));
    setURL("pdf_header_margin_bottom", getTypedVal("pdf_header_margin_bottom", "1cm"));
    setURL("pdf_header_margin_left", getTypedVal("pdf_header_margin_left", "1.5cm"));
    setURL("pdf_header_margin_right", getTypedVal("pdf_header_margin_right", "1cm"));
    return `${new_url}&lang_code=${language}&project_id=${reportId}&project=${reportName}&road_name=${reportRoadName}&location=${reportLocation}&comment=${reportComment}&hostname=${hostName}`;
  }

  const new_url = hostName + pdfLink.replace(location.host, "").replace("http://", "").replace("https://", "");
  return `${new_url}&lang_code=${language}&project_id=${reportId}&project=${reportName}&road_name=${reportRoadName}&location=${reportLocation}&comment=${reportComment}&hostname=${hostName}&${getURL()}`;
}

export function createLDTLink(ldtLink: string, language: string): string {
  const hostName = API_URL;
  const { reportComment, reportId, reportLocation, reportName, reportRoadName } = getResultFormData();
  return `${ldtLink}&lang_code=${language}&project_id=${reportId}&project=${reportName}&road_name=${reportRoadName}&location=${reportLocation}&comment=${reportComment}&hostname=${hostName}`;
}

export function createRecadzLink(recadzLink: string, language: string): string {
  const hostName = API_URL;
  const { reportComment, reportId, reportLocation, reportName, reportRoadName } = getResultFormData();
  return `${recadzLink}&lang_code=${language}&project_id=${reportId}&project=${reportName}&road_name=${reportRoadName}&location=${reportLocation}&comment=${reportComment}&hostname=${hostName}`;
}

export function createExcellLink(requestHash: string): string {
  const { reportId, reportLocation, reportName, reportRoadName } = getResultFormData();
  return `${API_URL}/api/find-street/${requestHash}?project_id=${reportId}&project=${reportName}&road_name=${reportRoadName}&location=${reportLocation}`;
}
